import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Sector } from 'src/app/models/ms_sector';
import { Referential } from 'src/app/models/referential';
import { ServiceResponse } from 'src/app/models/service-response';
import { CityService } from 'src/app/rest_services/city.service';
import { ClassService } from 'src/app/rest_services/class.service';
import { ProductCategoryService } from 'src/app/rest_services/family.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SectorService } from 'src/app/rest_services/sector.service';
import { TopicService } from 'src/app/rest_services/topic.service';
import { validLabelValidator } from 'src/app/validators/ref-labels.validator';

@Component({
  selector: 'app-referential',
  templateUrl: './referential.component.html',
  styleUrls: ['./referential.component.css']
})
export class ReferentialComponent implements OnInit, OnDestroy {

  update:boolean=false;
  updateC:boolean=false;
  updateT:boolean=false;
  updateFl:boolean=false;

  message: string = '';
  success:boolean=false;
  successProductCategory:boolean=false;
  successTopic:boolean=false;
  fail:boolean=false;
  failProductCategory:boolean=false;
  failTopic:boolean=false;
  loader:boolean=false;

  sectors: any[] = [];
  cities: Array<Referential> = [];
  topics: Array<Referential> = [];
  classes: Array<Referential> = [];
  categories: Array<Referential> = [];

  sectorsLoader:boolean=true;
  citiesLoader:boolean=true;
  topicsLoader:boolean=true;
  classesLoader:boolean=true;
  categoriesLoader:boolean=true;

  sectorToDelete!:any;
  cityToDelete!:Referential;
  topicToDelete!:Referential;
  productCategoryToDelete!:Referential;

  sectorForm!: FormGroup;
  cityForm!: FormGroup;
  topicForm!: FormGroup;
  productCategoryForm!: FormGroup;

  sectorsFiltered: any[] = [];
  citiesFiltered: Array<Referential> = [];
  topicsFiltered: Array<Referential> = [];
  classesFiltered: Array<Referential> = [];
  categoriesFiltered: Array<Referential> = [];

  sectorSearchForm!:FormGroup;
  citySearchForm!:FormGroup;
  topicSearchForm!:FormGroup;
  classSearchForm!:FormGroup;
  productCategorySearchForm!:FormGroup;

  sectorsSubscription!:Subscription;
  addSectorSubscription!:Subscription;
  updateSectorSubscription!:Subscription;
  deleteSectorSubscription!:Subscription;

  citiesSubscription!:Subscription;
  addCitySubscription!:Subscription;
  updateCitySubscription!:Subscription;
  deleteCitySubscription!:Subscription;

  topicsSubscription!:Subscription;
  addTopicSubscription!:Subscription;
  updateTopicSubscription!:Subscription;
  deleteTopicSubscription!:Subscription;

  classesSubscription!:Subscription;

  categoriesSubscription!:Subscription;
  addProductCategorySubscription!:Subscription;
  updateProductCategorySubscription!:Subscription;
  deleteProductCategorySubscription!:Subscription;
  checkUseProductCategorySubscription!:Subscription;

  token : any = '';

  constructor(private formBuilder: FormBuilder,
              private sectorService: SectorService,
              private cityService: CityService,
              private msSector : MsSectorService,
              private topicService: TopicService,
              private productCategoryService: ProductCategoryService,
              private classService: ClassService) { 
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
      if (window.screen.width <= 860) this.medium = true;
    }
  }

  mobile:boolean=false;
  medium:boolean=false;
  ngOnInit(): void {
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.initForms();
    this.getSectors();
    this.getCities();
    this.getTopics();
    this.getClasses();
    this.getCategories();
    this.sectorSearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.sectorsFiltered = this.filterSectors(el);
    });
    this.citySearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.citiesFiltered = this.filterCities(el);
    });
    this.topicSearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.topicsFiltered = this.filterTopics(el);
    });
    this.classSearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.classesFiltered = this.filterClasses(el);
    });
    this.productCategorySearchForm.controls['search'].valueChanges.subscribe(el=>{
      if(el!=""){
        this.categoriesFiltered = this.filterCategories(el);
      }else {
        this.categoriesFiltered = this.categories;
      }
    });
    
  }

  initForms(){
    this.sectorForm = this.formBuilder.group({
      sector:['', Validators.required],
      uuid:['']
    });
    this.cityForm = this.formBuilder.group({
      city:['', Validators.required],
      uuid:['']
    });
    this.topicForm = this.formBuilder.group({
      topic:['', [Validators.required, validLabelValidator]],
      uuid:['']
    });
    this.sectorSearchForm = this.formBuilder.group({
      search:[''],
    });
    this.citySearchForm = this.formBuilder.group({
      search:[''],
    });
    this.topicSearchForm = this.formBuilder.group({
      search:[''],
    });
    this.classSearchForm = this.formBuilder.group({
      search:[''],
    });
    this.productCategorySearchForm = this.formBuilder.group({
      search:[''],
    });
    this.productCategoryForm = this.formBuilder.group({
      productCategory:['', Validators.required],
      uuid:['']
    });
  }

  filterSectors(search: string){
    return this.sectors.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.label && el.label.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }
  
  filterCities(search: string){
    return this.cities.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.city && el.city.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }

  filterTopics(search: string){
    return this.topics.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.topic && el.topic.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }

  filterClasses(search: string){
    return this.classes.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.refClass && el.refClass.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }

  filterCategories(search: string){
    return this.categoriesFiltered.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.category && el.category.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }

  //#region Refs Retrieves
  getSectors(){
    this.msSector.getSectors(this.token);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.sectors = data.sectors;
          this.sectorsFiltered = this.sectors
          .filter((item) => item.label !== undefined)
          .sort((a, b) => {
            if (a.label && b.label) {
              return a.label.localeCompare(b.label);
            } else if (a.label) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.sectorsLoader=false;       
      },(error :any) => {
        console.log(error);
        this.sectorsLoader=false;   
      }
    )  
  }
  getCities(){
    this.citiesSubscription = this.cityService.getCities().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "9d0907561104ccc6b9d188f036bd358c"){
          this.cities = data.cities?data.cities:[];
          this.citiesFiltered = this.cities
          .filter((item) => item.city !== undefined) // Filter out elements with undefined city
          .sort((a, b) => {
            if (a.city && b.city) {
              return a.city.localeCompare(b.city);
            } else if (a.city) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.citiesLoader=false;         
      },
      (error) => {
        console.log(error);
        this.citiesLoader=false;   
      }
    );
  }
  getTopics(){
    this.topicsSubscription = this.topicService.getTopics().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "d9cc2e7dc2cf71242be86ab1ad241752"){
          this.topics = data.topics?data.topics:[];
          this.topicsFiltered = this.topics
          .filter((item) => item.topic !== undefined) // Filter out elements with undefined topic
          .sort((a, b) => {
            if (a.topic && b.topic) {
              return a.topic.localeCompare(b.topic);
            } else if (a.topic) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.topicsLoader=false;         
      },
      (error) => {
        console.log(error);
        this.topicsLoader=false;   
      }
    );
  }
  getClasses(){
    this.classesSubscription = this.classService.getClasses().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "7cd8d69b7048301e37f4ddaf4959218c"){
          this.classes = data.classes?data.classes:[];
          this.classesFiltered = this.classes;
        }
        this.classesLoader=false;         
      },
      (error) => {
        console.log(error);
        this.classesLoader=false;   
      }
    );
  }
  getCategories(){
    this.categoriesSubscription = this.productCategoryService.getProductCategories().subscribe(
      (data: ServiceResponse) => {        
        if(data.code == "cf0e0d96d99d8cd08b9f74c6dd7c1bb8"){          
          this.categories = data.categories?data.categories:[];          
          this.categoriesFiltered = this.categories
          .filter((item) => item.category !== undefined) // Filter out elements with undefined topic
          .sort((a, b) => {
            if (a.category && b.category) {
              return a.category.localeCompare(b.category);
            } else if (a.category) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.categoriesLoader=false;         
      },
      (error) => {
        console.log(error);
        this.categoriesLoader=false;   
      }
    );
  }
  //#endregion

  //#region Sectors Management
  addSector(){
    this.message = 'Ajout du secteur';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.update=false;
    let sector :any ={};
    sector.label = this.sectorForm.controls.sector.value;
    this.msSector.addSector(this.token, sector);
    this.msSector.newSectorSubject.subscribe(
      (data: any) => {
        if(data.message == "Sector already exist !"){
          this.loader=false;
          this.message = 'Secteur existe déja';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else if(data.message == "Invalid data !" || data.message =="Technical error"){
          this.loader=false;
          this.message = 'Secteur non ajouté';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }else {
          let sectorAdded = data.sector;
          if(sectorAdded){
            let sect:any = {label:sectorAdded.label?sectorAdded.label:"",id:sectorAdded.id};
            this.sectors.push(sect);
            this.sectorsFiltered= this.sectors.sort((a : any, b : any) => a.label.localeCompare(b.label)); //sort sectors alphabetically;
          }
          this.sectorForm.reset();
          this.loader=false;
          this.message = 'Secteur ajouté avec succès';
          this.success = true;
          
          setTimeout(() => {
            this.success = false;
          }, 5000);
        }
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Secteur non ajouté';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  updateSector(item:any){
    this.update=true;
    this.sectorForm.patchValue({
      sector: item.label,
      uuid: item.id
    })
  }

  submitToUpdateSector(){
    this.message = 'Modification du secteur';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    let sector:any ={};
    sector.label = this.sectorForm.controls.sector.value;
    sector.id = this.sectorForm.controls.uuid.value;
    this.msSector.updateSector(this.token, sector);
    this.msSector.updateSectorSubject.subscribe(
      (data: any) => {
        if (data.message && data.message.includes("updated with success")) {
          let index = this.sectors?.findIndex(e=>e.id == sector.id)
          if(index!=undefined){
            this.sectors?.splice(index,1,sector);
            this.sectorsFiltered= this.sectors;
          }
          this.sectorForm.reset();
          this.loader=false;
          this.update=false;
          this.message = 'Secteur modifié avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if (data.message == "Sector already exist !") {
          this.loader=false;
          this.message = 'Secteur existe déja'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else {
          this.loader=false;
          this.message = 'Secteur non modifié'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Secteur non modifié';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  getSector(sector:any){
    this.sectorToDelete = sector;
  }

  deleteSector(id:string){
    this.message = 'Suppression du secteur';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.deleteSectorSubscription = this.sectorService.deleteSector(id).subscribe(
      (data: ServiceResponse) => {
        if(data.code == "68eb94594d32c0cb4942b385e1bafc39") {
          this.loader=false;
          this.message = 'Secteur non supprimé: des clients appartiennentt à ce secteur';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } 
        else {
          this.msSector.deleteSector(this.token, id);
          this.msSector.deleteSectorSubject.subscribe(
            (response: any) => {
              if (response.message && response.message.includes("deleted successfully")) {
                let index = this.sectors?.findIndex(e=>e.id == id)
                if(index!=undefined){
                  this.sectors.splice(index,1);
                  this.sectorsFiltered= this.sectors;
                }
                this.loader=false;
                this.message = 'Secteur supprimé avec succès';
                this.success = true;
                setTimeout(() => {
                  this.success = false;
                }, 5000);
              } else if(response.message && response.message.includes("Sector not found")) {
                this.loader=false;
                this.message = 'Secteur n\'existe pas';
                this.fail = true;
                setTimeout(() => {
                  this.fail = false;
                }, 5000);
              } else {
                this.loader=false;
                this.message = 'Secteur non supprimé';
                this.fail = true;
                setTimeout(() => {
                  this.fail = false;
                }, 5000);
              }
                     
            },
            (error) => {
              console.log(error);
              this.loader=false;
              this.message = 'Secteur non supprimé';
              this.fail = true;
              setTimeout(() => {
                this.fail = false;
              }, 5000);
            }
          );
        }      
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Secteur non supprimé';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }
  //#endregion

  //#region Cities Management
  addCity(){
    this.message = 'Ajout de la ville';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.updateC = false;
    let city = new Referential();
    city.name = this.cityForm.controls.city.value;
    this.addCitySubscription = this.cityService.addCity(city).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "5885ba91e80c4507cb1e35548129c3c0") {
          let topicAdded = data.city;
          if(topicAdded){
            let cit:Referential = {city:topicAdded.name?topicAdded.name:"",uuid:topicAdded.uuid}
            this.cities.push(cit);
            this.citiesFiltered= this.cities.sort((a : any, b : any) => a.city.localeCompare(b.city)); //sort cities alphabetically;
          }
          this.cityForm.reset();
          this.loader=false;
          this.message = 'Ville ajoutée avec succès';
          this.success = true;
          
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if(data.code == "a6e243dd4f515aa112410877740174b8") {
          this.loader=false;
          this.message = 'Ville existe déja';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else {
          this.loader=false;
          this.message = 'Ville non ajoutée';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'ville non ajoutée';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  updateCity(item:Referential){
    this.updateC=true;
    this.cityForm.patchValue({
      city: item.city,
      uuid: item.uuid
    })
  }

  submitToUpdateCity(){
    this.message = 'Modification de la ville';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    let city = new Referential();
    city.name = this.cityForm.controls.city.value;
    city.uuid = this.cityForm.controls.uuid.value;
    this.updateCitySubscription = this.cityService.updateCity(city).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "5876ea7b868466034493a62859371897") {
          let el= new Referential();
          el.uuid = data.city?.uuid? data.city?.uuid: '';
          el.city = data.city?.name;
          let index = this.cities?.findIndex(e=>e.uuid == el.uuid)
          if(index != null){
            this.cities?.splice(index,1,el);
          }
          this.citiesFiltered= this.cities;
          this.cityForm.reset();
          this.loader=false;
          this.updateC=false;
          this.message = 'Ville modifiée avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if (data.code == "7539deff3efc02fe4e93aceb4a9885f7"){
          this.loader=false;
          this.message = 'Ville existe déja'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }else{
          this.loader=false;
          this.message = 'Ville non modifiée'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Ville non modifiée';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  getCity(city:Referential){
    this.cityToDelete = city;
  }

  deleteCity(uuid:string){
    this.message = 'Suppression de la ville';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.deleteCitySubscription = this.cityService.deleteCity(uuid).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "2b7a32a45799ce3f0e8dc7ee146b5338") {
          let index = this.cities?.findIndex(e=>e.uuid == uuid)
          if(index)
          this.cities?.splice(index,1);
          this.citiesFiltered= this.cities;
          this.loader=false;
          this.message = 'Ville supprimée avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
          
        } else if (data.code == "3a5f4469b340d70b897b82d38533b4f4") {
          this.loader=false;
          const nbCustomer = data.totalCustomers;
          this.message = `Suppression impossible : cette ville est affectée à ${nbCustomer} clients`;
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 7000);
        } else {
          this.loader=false;
          this.message = 'Ville non supprimée';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Ville non supprimée';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }
  //#endregion

  //#region Topics Management
  addTopic(){
  this.message = 'Ajout du topic';
  this.topicsLoader=true;
  this.updateT = false;
  let topic = new Referential();
  topic.name = this.topicForm.controls.topic.value?.trim();
  this.addTopicSubscription = this.topicService.addTopic(topic).subscribe(
    (data: ServiceResponse) => {
      this.topicsLoader=false;
      if (data.code == "662a1237ac8d60871bec841ac4a29e7e") {
        let topicAdded = data.topic;
        if(topicAdded) {
          let top:Referential = {topic:topicAdded.name?topicAdded.name:"",uuid:topicAdded.uuid}
          this.topics.push(top);
          this.topicsFiltered= this.topics.sort((a : any, b : any) => a.topic.localeCompare(b.topic));
        }
        this.topicForm.reset();
        this.message = 'Topic ajouté avec succès';
        this.successTopic = true;
        setTimeout(() => {
          this.successTopic = false;
        }, 5000);
      } else if (data.code == "53765b8627704f3f4104bdf8a667179f") {
        this.message = 'Topic existe déjà';
        this.failTopic = true;
        setTimeout(() => {
          this.failTopic = false;
        }, 5000);
      } else if (data.code == "b657116656d56a69061cc8ddb3ad7eca") {
        this.message = 'Le topic contient des caractères non autorisés (la virgule par exemple)';
        this.failTopic = true;
        setTimeout(() => {
          this.failTopic = false;
        }, 5000);
      } else if (data.code == "1ce894fdcecf0c6129d9d5a78cd92ff1") {
        this.message = 'Le topic est obligatoire';
        this.failTopic = true;
        setTimeout(() => {
          this.failTopic = false;
        }, 5000);
      } else {
        this.message = 'Topic non ajouté';
        this.failTopic = true;
        setTimeout(() => {
          this.failTopic = false;
        }, 5000);
      }
    },
    (error) => {
      console.log(error);
      this.topicsLoader=false;
      this.message = 'Topic non ajouté';
      this.failTopic = true;
      setTimeout(() => {
        this.failTopic = false;
      }, 5000);
    }
  );
  }

  updateTopic(item:Referential){
    this.updateT=true;
    this.topicForm.patchValue({
      topic: item.topic,
      uuid: item.uuid
    })
  }

  submitToUpdateTopic(){
    this.message = 'Modification du topic';
    this.topicsLoader=true;
    let topic = new Referential();
    topic.name = this.topicForm.controls.topic.value?.trim();
    topic.uuid = this.topicForm.controls.uuid.value;
    this.updateTopicSubscription = this.topicService.updateTopic(topic).subscribe(
      (data: ServiceResponse) => {
        this.topicsLoader=false;
        if (data.code == "afcbd1b891d62ba8b6916cb430c2b5de") {
          let el= new Referential();
          el.uuid = data.topic?.uuid? data.topic?.uuid: '';
          el.topic = data.topic?.name;
          let index = this.topics?.findIndex(e=>e.uuid == el.uuid);
          if(index !== undefined && index !== -1){
            this.topics.splice(index,1,el);
          }
          this.topicsFiltered= this.topics.sort((a : any, b : any) => a.topic.localeCompare(b.topic));
          this.topicForm.reset();
          this.updateT=false;
          this.message = 'Topic modifié avec succès';
          this.successTopic = true;
          setTimeout(() => {
            this.successTopic = false;
          }, 5000);
        } else if(data.code == "984fea95f7a405a95d7fc0b403b2ef82"){
          this.message = 'Topic existe déjà';
          this.failTopic = true;
          setTimeout(() => {
            this.failTopic = false;
          }, 5000);
        } else if(data.code == "aac581925412a6e0b8fa0be12a280b72"){
          this.message = "La virgule n'est pas autorisée dans le topic";
          this.failTopic = true;
          setTimeout(() => {
            this.failTopic = false;
          }, 5000);
        } else if(data.code == "71063d634367ea207730429f35ce2d6a"){
          this.message = 'Le topic contient des caractères non autorisés';
          this.failTopic = true;
          setTimeout(() => {
            this.failTopic = false;
          }, 5000);
        } else if(data.code == "122bd5e354e3d99d854bfc470f4de11a"){
          this.message = 'Données invalides ou topic introuvable';
          this.failTopic = true;
          setTimeout(() => {
            this.failTopic = false;
          }, 5000);
        } else {
          this.message = 'Topic non modifié';
          this.failTopic = true;
          setTimeout(() => {
            this.failTopic = false;
          }, 5000);
        }
      },
      (error) => {
        console.log(error);
        this.topicsLoader=false;
        this.message = 'Topic non modifié';
        this.failTopic = true;
        setTimeout(() => {
          this.failTopic = false;
        }, 5000);
      }
    );
  }

  getTopic(topic:Referential){
    this.topicToDelete = topic;
  }

  deleteTopic(uuid:string){
    this.message = 'Suppression du topic';
    this.topicsLoader=true;
    // $("html, body").animate({scrollTop:0});
    this.deleteTopicSubscription = this.topicService.deleteTopic(uuid).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "b1747f8a235636d87190d1b1c8eb0fa8") {
          const index = this.topics?.findIndex(e => e.uuid == uuid) ?? -1;
          if (index > -1) {
            this.topics.splice(index, 1);
          }
          this.topicsFiltered= this.topics;
          this.topicsLoader=false;
          this.message = 'Topic supprimé avec succès';
          this.successTopic = true;
          setTimeout(() => {
            this.successTopic = false;
          }, 5000);
          
        } else if (data.code == "c309e1dfed3ab769f14063719353327a"){
          this.topicsLoader=false;
          this.message = 'Topic non supprimé: des vistes ont ce topic';
          this.failTopic = true;
          setTimeout(() => {
            this.failTopic = false;
          }, 5000);
        } else {
          this.topicsLoader=false;
          this.message = 'Topic non supprimé';
          this.failTopic = true;
          setTimeout(() => {
            this.failTopic = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.topicsLoader=false;
        this.message = 'Topic non supprimé';
        this.failTopic = true;
        setTimeout(() => {
          this.failTopic = false;
        }, 5000);
      }
    );
  }
  //#endregion

  //#region Categories Management
  addProductCategory(){
    this.message = 'Ajout du famille';
    this.categoriesLoader=true;
    // $("html, body").animate({scrollTop:0});
    this.updateFl = false;
    let productCategory = new Referential();
    productCategory.name = this.productCategoryForm.controls.productCategory.value;
    this.addProductCategorySubscription = this.productCategoryService.addProductCategory(productCategory).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "cc191cb9f4f909c50fd54aafc892e283") {          
          let productCategoryAdded = data.productCategory;
          if(productCategoryAdded) {
            let top:Referential = {category:productCategoryAdded.name?productCategoryAdded.name:"",uuid:productCategoryAdded.uuid}
            this.categories.push(top);            
            this.categoriesFiltered= this.categories.sort((a : any, b : any) => a.category.localeCompare(b.category)); //sort categories alphabetically;
          }
          this.productCategoryForm.reset();
          this.categoriesLoader=false;
          this.message = 'famille ajoutée avec succès';
          this.successProductCategory = true;
          
          setTimeout(() => {
            this.successProductCategory = false;
          }, 5000);
        } else if (data.code == "662b63631dd906a4a8c9dbb7706e80d6") {
          this.categoriesLoader=false;
          this.message = 'famille existe déja';
          this.failProductCategory = true;
          setTimeout(() => {
            this.failProductCategory = false;
          }, 5000);
        } else {
          this.categoriesLoader=false;
          this.message = 'famille non ajoutée';
          this.failProductCategory = true;
          setTimeout(() => {
            this.failProductCategory = false;
          }, 5000);
        }
      },
      (error) => {
        console.log(error);
        this.categoriesLoader=false;
        this.message = 'famille non ajoutée';
        this.failProductCategory = true;
        setTimeout(() => {
          this.failProductCategory = false;
        }, 5000);
      }
    );
  }

  updateProductCategory(item:Referential){
    this.updateFl=true;
    this.productCategoryForm.patchValue({
      productCategory: item.category,
      uuid: item.uuid
    })
  }

  infoCrudMessage:any="";
  submitToUpdateProductCategory(){
    this.message = 'Modification du famille';
    this.categoriesLoader=true;
    // $("html, body").animate({scrollTop:0});
    let productCategory = new Referential();
    productCategory.name = this.productCategoryForm.controls.productCategory.value;
    productCategory.uuid = this.productCategoryForm.controls.uuid.value;
    this.updateProductCategorySubscription = this.productCategoryService.updateProductCategory(productCategory).subscribe(
      (data: any) => {
        if (data.code == "42dcad27cd7ecd0c02e0a31a2b7e62c2") {
          let el= new Referential();          
          el.uuid = data.productCategory?.uuid? data.productCategory?.uuid: '';
          el.category = data.productCategory?.name;
          let index = this.categories?.findIndex(e=>e.uuid == el.uuid)
          if(index != null){
            this.categories?.splice(index,1,el);
          }
          this.categoriesFiltered= this.categories;
          this.productCategoryForm.reset();
          this.categoriesLoader=false;
          this.updateFl=false;
          this.message = 'Famille modifiée avec succès';
          this.successProductCategory = true;
          setTimeout(() => {
            this.successProductCategory = false;
          }, 5000);
          if(data.details!=undefined && data.details!=null){
            this.infoCrudMessage = "Modification réussie";
            this.echecDetails = data.details?.salesInfos;
            this.echecDetails.sort((a, b) => {
              const dateA = new Date(a.saleDate).getTime();
              const dateB = new Date(b.saleDate).getTime();
              return dateB - dateA ;
            });
          }
        } else if(data.code == "5aa1181e9883c675cfeef91d26d9cccc"){
          this.categoriesLoader=false;
          this.message = 'Famille existe déja'
          this.failProductCategory = true;
          setTimeout(() => {
            this.failProductCategory = false;
          }, 5000);
        } else {
          this.categoriesLoader=false;
          this.message = 'Famille non modifiée'
          this.failProductCategory = true;
          setTimeout(() => {
            this.failProductCategory = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Famille non modifiée';
        this.failProductCategory = true;
        setTimeout(() => {
          this.failProductCategory = false;
        }, 5000);
      }
    );
  }

  getProductCategory(productCategory:Referential){
    this.productCategoryToDelete = productCategory;
  }

  echecDetails:any[]=[];
  deleteProductCategory(uuid:string){
    this.message = 'Suppression du famille';
    this.categoriesLoader=true;
    let index = this.categoriesFiltered?.findIndex(e=>e.uuid == uuid)
    // $("html, body").animate({scrollTop:0});
    this.deleteProductCategorySubscription = this.productCategoryService.deleteProductCategory(uuid).subscribe(
      (data: any) => {
        if (data.code == "ef7103c23ba72bab88d164d430cc0227") {
          if(index) {
            this.categories?.splice(index,1);
            this.categoriesFiltered= this.categories;
          }
          this.categoriesLoader=false;
          this.message = 'Famille supprimée avec succès';
          this.successProductCategory = true;
          setTimeout(() => {
            this.successProductCategory = false;
          }, 5000);
        } else {
          if(data.details!=undefined && data.details!=null){
            this.infoCrudMessage = "La famille ne peut pas être supprimée car elle est liée à des ventes !"
            this.echecDetails = data.details?.salesInfos;
            this.echecDetails.sort((a, b) => {
              const dateA = new Date(a.saleDate).getTime();
              const dateB = new Date(b.saleDate).getTime();
              return dateB - dateA ;
            });
            this.updateHasImpact=false;
            setTimeout(()=>{
              // (<any>$("#echecDeleteFamily")).modal('show');
              ($('#echecDeleteFamily') as any).modal('show');
            }, 500);
          }
          this.categoriesLoader=false;
          this.message = 'Famille non supprimée';
          this.failProductCategory = true;
          setTimeout(() => {
            this.failProductCategory = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.categoriesLoader=false;
        this.message = 'ProductCategory non supprimé';
        this.failProductCategory = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }
  cancelUpdProductCategory() {
    this.categoriesFiltered= this.categories;
    this.productCategoryForm.reset();
    this.loader=false;
    this.updateFl=false;
  }
  //#endregion

  ngOnDestroy(): void {
    this.sectorsSubscription?.unsubscribe();
    this.addSectorSubscription?.unsubscribe();
    this.updateSectorSubscription?.unsubscribe();
    this.deleteSectorSubscription?.unsubscribe();
  
    this.citiesSubscription?.unsubscribe();
    this.addCitySubscription?.unsubscribe();
    this.updateCitySubscription?.unsubscribe();
    this.deleteCitySubscription?.unsubscribe();
  
    this.topicsSubscription?.unsubscribe();
    this.addTopicSubscription?.unsubscribe();
    this.updateTopicSubscription?.unsubscribe();
    this.deleteTopicSubscription?.unsubscribe();

    this.classesSubscription?.unsubscribe();

    this.categoriesSubscription?.unsubscribe();
    this.addProductCategorySubscription?.unsubscribe();
    this.updateProductCategorySubscription?.unsubscribe();
    this.deleteProductCategorySubscription?.unsubscribe();
    this.checkUseProductCategorySubscription?.unsubscribe();
  }

  loadingChecking:boolean=false;
  // messageChecking:any="";
  updateHasImpact:boolean = false;
  checkUseOfProductCategory(){
    this.loadingChecking=true;
    setTimeout(()=>{
      ($('#echecDeleteFamily') as any).modal('show');
    }, 500);
    var uuid = this.productCategoryForm.controls.uuid.value;
    this.checkUseProductCategorySubscription = this.productCategoryService.checkUseProductCategory(uuid).subscribe(
      (data: any) => {
        if (data.code == "b6247839866d613c8d06e72fd79b05cd") { //Family used
          this.loadingChecking=false;
          this.updateHasImpact = true;
          this.infoCrudMessage = "La famille que vous êtes en train de modifier est liée à des ventes"
          this.echecDetails = data.details?.salesInfos;
          this.echecDetails.sort((a, b) => {
            const dateA = new Date(a.saleDate).getTime();
            const dateB = new Date(b.saleDate).getTime();
            return dateB - dateA ;
          });
        } else {
          this.loadingChecking=false;
          this.updateHasImpact = false;
          if(data.code == "1588de2f63678dff02a4d7256d67b21f"){ //Family not used
            this.submitToUpdateProductCategory();
            setTimeout(()=>{
              ($('#echecDeleteFamily') as any).modal('hide');
            }, 500);
          }
        } 
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = "Famille n'est pas modifiée";
        this.failProductCategory = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

}
